[
  {
    "code": "BAC",
    "name": "Baccarat"
  },
  {
    "code": "MBAC",
    "name": "Micard Baccarat"
  },
  {
    "code": "DT",
    "name": "Dragon Tiger"
  },
  {
    "code": "DTW",
    "name": "Dragon Tiger Wild"
  },
  {
    "code": "SIC",
    "name": "SicBo"
  },
  {
    "code": "MWSIC",
    "name": "Max Win SicBo"
  },
  {
    "code": "ROU",
    "name": "Roulette"
  },
  {
    "code": "BJ",
    "name": "Blackjack"
  },
  {
    "code": "ABJ",
    "name": "ABJ"
  },
  {
    "code": "NIU",
    "name": "Niu Niu"
  },
  {
    "code": "3F",
    "name": "Three Face"
  },
  {
    "code": "W3C",
    "name": "Win Three Card"
  },
  {
    "code": "12D",
    "name": "12D"
  },
  {
    "code": "24D",
    "name": "24D"
  },
  {
    "code": "D6F",
    "name": "Dice 6 Flash"
  },
  {
    "code": "D6G",
    "name": "Dice 6 Girl"
  },
  {
    "code": "MWMJ",
    "name": "Max Win Majong Drop"
  },
  {
    "code": "RW",
    "name": "Red White"
  }
]
